@if (splitInputs) {
  <s-form-row>
    <s-form-input-date
      [fieldName]="fieldName"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
      [readonly]="readonly"
      [label]="dateLabel"
      [groupName]="groupName"
      [displayHint]="displayHint"
      [leaveTimeAlone]="true"
    />
    <s-form-input-time
      [fieldName]="fieldName"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
      [readonly]="readonly"
      [label]="timeLabel"
      [groupName]="groupName"
      [displayHint]="displayHint"
      [oneSecUnknown]="!showSeconds"
      [showSeconds]="showSeconds"
      format="time"
    />
  </s-form-row>
} @else {
  @if (fieldName) {
    <div class="form-group">
      <p-float-label>
        <p-date-picker
          [showIcon]="!readonly"
          [(ngModel)]="dateValue"
          [inputId]="inputId"
          [showClear]="!isRequired() && !readonly"
          [selectOtherMonths]="true"
          [showTime]="true"
          [showSeconds]="showSeconds"
          appendTo="body"
          (onBlur)="onChange()"
          (onSelect)="onChange()"
          (onClear)="onChange()"
          (onShow)="onShow()"
          (onClose)="onClose()"
          [readonlyInput]="readonly"
          [showOnFocus]="layoutService.desktop$ | async"
          [touchUI]="layoutService.mobile$ | async"
        />
        <label [for]="inputId"
          >{{ label ?? 'Date' }}
          @if (isRequired()) {
            <span style="color: red">*</span>
          }
        </label>
      </p-float-label>
      <ng-content></ng-content>
      @if (displayHint) {
        <small class="block" style="font-weight: normal">{{ displayHint }}</small>
      }
      <s-form-error-input
        [groupName]="groupName"
        [fieldName]="fieldName"
        [form]="form"
        [apiError]="apiError"
        [schema]="schema"
      />
    </div>
  }
}
